import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { useGetMainPathType } from "./useGetMainPathType";

import { ENav } from "components/Layout/types";
import { buSlugParam, comSlugParam, corpSlugParam } from "routes/constants";

export const useGetEntityParamId = () => {
  const params = useParams();
  const mainPath = useGetMainPathType();
  const [paramId, setParamId] = useState("");

  useEffect(() => {
    switch (mainPath) {
      case ENav.COMMUNITY:
        setParamId(params?.[comSlugParam] || "");
        break;
      case ENav.BUSINESS_UNIT:
        setParamId(params?.[buSlugParam] || "");
        break;
      case ENav.CORPORATION:
        setParamId(params?.[corpSlugParam] || "");
        break;
      default:
        setParamId("");
        break;
    }
  }, [mainPath, params]);

  return paramId;
};
